import React from 'react'
import questions from './questions_data/questions';
import questions_chi from './questions_data/questions_chi'
import AnswerList from './AnswerList';
import { Button, Typography, Grid } from '@mui/material';
import SubmitButton from './small_components/SubmitButton';


function Questions({ state, setState, currentQuestion, setCurrentQuestion, createUser, language }) {
    const prevQuestion = currentQuestion - 1;
    const nextQuestion = currentQuestion + 1;
    let otherValues = 0;

    //Check if state have others
    if (Object.keys(state).includes("ethnicity_others")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("grandfather")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("skin_concerns_others")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("conditions_others")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("allergic_others")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("diseases_others")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("drugs_others")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("medications_others")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("health_goals_others")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("health_others")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Antibiotics")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Anti")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Blood_Pressure")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Cholesterol")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Diabetes")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Diuretics")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Hormone")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Facilitate")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Gout")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Salicylate")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Thyroid")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Blood_thinning")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Painkillers")) {
        otherValues = otherValues + 1
    }
    if (Object.keys(state).includes("Other")) {
        otherValues = otherValues + 1
    }

    //Goes to the next question
    function goNextQuestion() {
        if (nextQuestion <= questions.length) {
            setCurrentQuestion(nextQuestion);
            if (document.querySelector('.MuiInput-input')) {
                document.querySelector('.MuiInput-input').focus();
            }
        }
    };

    //Goes to the previous question
    function goPrevQuestion() {
        if (currentQuestion > 0) {
            setCurrentQuestion(prevQuestion)
        }
    }

    //Handle the the state of the form fields.
    function handleChange(evt) {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value
        });
    }

    //Handle the state of the form fields, and brings the user to the next question.
    function handleChangeAndAnswer(evt) {
        handleChange(evt)
        currentQuestion = currentQuestion + 1
        goNextQuestion();
    }

    function NextButton() {
        if (currentQuestion < questions.length - 1) {
            return (
                <Button variant="contained"
                    disabled={!Object.keys(state)[currentQuestion + 1 + otherValues]}
                    onClick={goNextQuestion}
                    type="submit"
                    sx={{ width: "100%", height: "50px" }}
                >
                    Next
                </Button>
            )
        } else {
            return (
                <SubmitButton
                    createUser={createUser}
                    disabled={true}
                    state={state} />
            )
        }
    }
    const LanguageSelected = () => {
        if (language === "questions") {
            return (
                <Typography variant='h4' textAlign="center" sx={{ fontSize: { xs: '24px', sm: '36px;' } }}>{questions[currentQuestion].questionText}</Typography>
            )
        }
        else if (language === "questions_chi") {
            return (
                <Typography variant='h4' textAlign="center" sx={{ fontSize: { xs: '24px', sm: '36px;' } }}>{questions_chi[currentQuestion].questionText}</Typography>
            )
        }
    }

    if (currentQuestion <= questions.length) {
        return (
            <Grid container
                direction="row"
                justifyContent="center"
                alignItems="center"
                width="100%"
                spacing={{ xs: 2, md: 4 }}
                component="form">
                <Grid item mt={4}>
                    <LanguageSelected />
                </Grid>
                <Grid item xs={12} sx={{ textAlign: "center" }}>
                    <AnswerList
                        state={state}
                        setState={setState}
                        handleChange={handleChange}
                        currentQuestion={currentQuestion}
                        goNextQuestion={goNextQuestion}
                        handleChangeAndAnswer={handleChangeAndAnswer}
                        language={language}
                    />
                </Grid>
                <Grid item xs={12} sm={8}>
                    <Grid container
                        spacing={2}
                        display="flex"
                        justifyContent="center">
                        <Grid item xs={6}>
                            <Button variant="outlined"
                                disabled={currentQuestion === 0}
                                onClick={goPrevQuestion}
                                color="secondary"
                                sx={{ width: "100%", height: "50px" }}
                            >
                                Previous
                            </Button>
                        </Grid>
                        <Grid item xs={6}>
                            <NextButton />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}


export default Questions